import React from "react";
//#region types
import { DashoardTitleProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import Tags from "../tags";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const DashboardTitle: React.FC<DashoardTitleProps> = (props) => {
  return (
    <Grid container direction={"column"}>
      <Grid item className={cssExports.dashboardHeaderText}>
        {LocalizationHelperInstance.getFormattedMessage(props.title)}
      </Grid>
      <Grid item container direction="row" columnGap={1}>
        {props.subtitle && (
          <Grid item>
            <Tags
              tags={[LocalizationHelperInstance.getFormattedMessage(props.subtitle ?? "")]}
              className={props.defaultTagColor ?? cssExports.blueTag}
              surface={props.defaultTagSurface}
            />
          </Grid>
        )}
        {props.extraTags &&
          props.extraTags.map((tag, index) => (
            <Grid item key={`extra-tag-${index}`}>
              <Tags
                {...tag}
                className={tag.className ?? props.defaultTagColor ?? cssExports.blueTag}
                surface={tag.surface ?? props.defaultTagSurface}
              />
            </Grid>
          ))}
      </Grid>
    </Grid>
  );
};

export default DashboardTitle;
